import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MLOpsPage from "@/pages/service/MLOpsPage";

export const Route = createFileRoute("/service/mlops")({
  head: () => pageHead("Agentic Operations & MLOps", "Agentic operations and MLOps: production infrastructure for agentic AI and machine learning systems. Model lifecycle, observability, governance, and pipeline automation at scale.", "/service/mlops", false),
  component: MLOpsPage,
});
